import React from 'react';

const DescriptionMain = ({ text }) => {
  return <span className='description__main'>{text}</span>;
};

export default DescriptionMain;
